// Danh sách nhân sự (GET /api/v1/be/staffs) dùng cho Ghi nhận và @nhắc tên; tải một lần rồi dùng lại.
import { useEffect, useState } from 'react';
import { mixGetV1 } from 'services/mixin';
import { normalize, type Mention } from './socialStore';

export interface StaffOption {
  value: number;
  /** Tài khoản đăng nhập của nhân sự (để biết bài “nhắc đến tôi”) */
  userId: string | null;
  label: string;
  name: string;
  avatar: string | null;
  desc: string;
}

let cache: StaffOption[] | null = null;
let pending: Promise<StaffOption[]> | null = null;

export function loadStaff(): Promise<StaffOption[]> {
  if (cache) return Promise.resolve(cache);
  pending ??= mixGetV1('/api/v1/be/staffs', { limit: 500 })
    .then((res: any) => {
      cache = (res?.data?.items || []).map((s: any) => ({
        value: s.id,
        userId: s.user?.id != null ? String(s.user.id) : null,
        label: s.name,
        name: s.name,
        avatar: s.avatar || null,
        desc: [s.position, s.department?.name].filter(Boolean).join(' · '),
      }));
      return cache!;
    })
    .catch(() => { pending = null; return [] as StaffOption[]; });
  return pending;
}

export function useStaffOptions(enabled = true) {
  const [list, setList] = useState<StaffOption[]>(cache || []);
  const [loading, setLoading] = useState(!cache && enabled);
  useEffect(() => {
    if (!enabled || cache) return;
    let alive = true;
    setLoading(true);
    loadStaff().then(l => { if (alive) { setList(l); setLoading(false); } });
    return () => { alive = false; };
  }, [enabled]);
  return { list, loading };
}

/** Lọc nhân sự theo chữ gõ sau "@" (không phân biệt dấu) */
export const searchStaff = (list: StaffOption[], q: string, limit = 8) => {
  const k = normalize(q);
  return (k ? list.filter(s => normalize(s.name).includes(k)) : list).slice(0, limit);
};

export const toMention = (s: StaffOption): Mention => ({ id: s.value, userId: s.userId, name: s.name });
